fragment SavedListStubFragment on SavedFilter {
    id
    name
    countUrl
    createdTime
    htmlUrl
    htmlUrlPath
    filterString
    description
    entityType
    isShared
    sharedWithEntities {
        id
        name
    }
    isDeleteable
}
